<template>
  <SectionContainer class="content">
    <picture>
      <img src="@/assets/img/logo-icone.png" alt="CyberClass Logo Icone" />
    </picture>
    <h3>Que tal adquirir o <span>conhecimento</span> para alcançar seus objetivos?</h3>
    <PrimaryButton
      @click="$router.push({ name: 'subscribe' })"
    >Conquiste seus sonhos</PrimaryButton>
  </SectionContainer>
</template>

<script>
  import SectionContainer from '@/components/layout/SectionContainer'
  import PrimaryButton from '@/components/buttons/PrimaryButton'

  export default {
    components: {
      SectionContainer,
      PrimaryButton
    }
  }
</script>

<style scoped lang="scss">
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-right: 15px;
    padding-left: 15px;

    picture {
      margin-bottom: 30px;
    }

    h3 {
      font-family: 'Poppins';
      font-size: 36px;
      max-width: 360px;
      text-align: center;
      margin-bottom: 30px;

      span {
        color: #FF8000;
        font-weight: 400;
      }
    }
  }
</style>